import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { gioCongDongHoatDongApi } from '../../../api/gioCongDongHoatDongApi';
import { IGioCongDongHoatDongSelectRequest } from '../../../models/request/gio-cong-dong/IGioCongDongHoatDongSelectRequest';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { IGioCongDongHoatDongAddOrEdit } from '../../../models/response/gio-cong-dong/IGioCongDongHoatDongAddOrEdit';
import { eGioCongDongHoatDongActionTypeIds, IGioCongDongHoatDongActionTypes } from '../../action-types/gio-cong-dong/IGioCongDongHoatDongActionTypes';
import { actions } from '../../actions/actionsWrapper';


export function* gioCongDongHoatDongSaga(): any {
    yield takeLatest(eGioCongDongHoatDongActionTypeIds.LOAD_START, loadWorker)
    yield takeLatest(eGioCongDongHoatDongActionTypeIds.LOAD_DETAIL_START, loadDetailWorker)
    yield takeEvery(eGioCongDongHoatDongActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eGioCongDongHoatDongActionTypeIds.DELETE_START, deleteWorker)

}

function* loadWorker(action: IGioCongDongHoatDongActionTypes): any {
    const res: IBaseResponeModel = yield call(gioCongDongHoatDongApi.load, action.payload as IGioCongDongHoatDongSelectRequest)
    if (res.is_success) {
        yield put(actions.gioCongDongWrapper.hoatDong.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.gioCongDongWrapper.hoatDong.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* loadDetailWorker(action: IGioCongDongHoatDongActionTypes): any {
    const res: IBaseResponeModel = yield call(gioCongDongHoatDongApi.loadDetail, action.payload as number)
    if (res.is_success) {
        yield put(actions.gioCongDongWrapper.hoatDong.LOAD_DETAIL_SUCCESS(res.data))
    } else {
        yield put(actions.gioCongDongWrapper.hoatDong.LOAD_DETAIL_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: IGioCongDongHoatDongActionTypes): any {
    const res: IBaseResponeModel = yield call(gioCongDongHoatDongApi.save, action.payload as IGioCongDongHoatDongAddOrEdit)
    if (res.is_success) {
        yield put(actions.gioCongDongWrapper.hoatDong.SAVE_SUCCESS(res.data))
    } else {
        yield put(actions.gioCongDongWrapper.hoatDong.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IGioCongDongHoatDongActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(gioCongDongHoatDongApi.delete, payload)
    if (res.is_success) {
        yield put(actions.gioCongDongWrapper.hoatDong.DELETE_SUCCESS(undefined))
    } else {
        yield put(actions.gioCongDongWrapper.hoatDong.DELETE_ERROR(res.message ?? "Error"))
    }
}
